import { action } from 'satcheljs';

export interface UpdateIsDynamicColumnWidthEnabledActionMessage {
    newValue: boolean;
}
export const updateIsDynamicColumnWidthEnabled: (
    newValue: boolean
) => UpdateIsDynamicColumnWidthEnabledActionMessage = action(
    'updateIsDynamicColumnWidthEnabled',
    (newValue: boolean): UpdateIsDynamicColumnWidthEnabledActionMessage => ({
        newValue,
    })
);
